import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flame } from "lucide-react";
export function FlameLevelSwitcher({ availableLevels, currentLevel, onLevelChange, }) {
    // Don't show if only one level available
    if (availableLevels.length <= 1)
        return null;
    const getLevelLabel = (level) => {
        switch (level) {
            case 1:
                return "Easy";
            case 2:
                return "Classic";
            case 3:
                return "Advanced";
        }
    };
    return (_jsx("div", { className: "bg-card border-2 border-border rounded-lg p-4 shadow-[2px_2px_0_rgba(45,37,32,0.1)]", children: _jsxs("div", { className: "flex flex-col md:flex-row md:items-center md:justify-between gap-4", children: [_jsxs("div", { children: [_jsx("h3", { className: "text-[#5a4a3a] mb-1", children: "Choose Your Approach" }), _jsx("p", { className: "text-sm text-[#5a4a3a]/70", children: "Pick the version that matches your skill level and time" })] }), _jsx("div", { className: "flex flex-col sm:flex-row gap-2", children: availableLevels.map((level) => (_jsxs("button", { onClick: () => onLevelChange(level), className: `
                flex items-center gap-2 px-4 py-2 rounded-lg border-2 transition-all
                ${currentLevel === level
                            ? "bg-[#c85a3f] border-[#c85a3f] text-white shadow-[2px_2px_0_rgba(200,90,63,0.3)]"
                            : "bg-card border-border text-[#5a4a3a] hover:border-[#c85a3f]/30 hover:bg-[#c85a3f]/5"}
              `, children: [_jsx("div", { className: "flex", children: Array.from({ length: level }).map((_, i) => (_jsx(Flame, { className: `w-4 h-4 ${currentLevel === level ? "text-white fill-white" : "text-[#c85a3f] fill-[#c85a3f]"}` }, i))) }), _jsx("span", { className: "text-sm font-medium", children: getLevelLabel(level) })] }, level))) })] }) }));
}
